export const toCamelCase = (value: string) => {
  if (value.length < 2) {
    return value.toLowerCase();
  }

  return value.substring(0, 1).toLowerCase() + value.substring(1);
};

const diacriticsMap: [string, string][] = [
  ['ä', 'ae'],
  ['ö', 'oe'],
  ['ü', 'ue'],
];

export const removeDiacritics = (value?: string | null) => {
  if (!value) {
    return undefined;
  }

  let result = value;

  diacriticsMap.forEach((x) => {
    result = result.replaceAll(x[0], x[1]).replaceAll(x[0].toUpperCase(), x[1].toUpperCase());
  });

  return result.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export function hasFlag<T extends string>(value: T | null | undefined, flag: T) {
  if (typeof value !== 'string') {
    return false;
  }
  const values = value.split(',').map((v) => v.trim());
  return values.includes(flag);
}
